import React, { RefObject } from 'react';
import styled from 'styled-components';
import { SlideElementProps } from '../../presentationManager/PresentationManager';
import {
  smallMediaQuery,
  TopPageIndicatorsContainer,
} from '../Grid';

export const Container = styled(TopPageIndicatorsContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 2px 1px #a7a6a62b;
  padding-right: 60px;

  @media ${smallMediaQuery} {
    justify-content: flex-start;
    box-shadow: none;
  }
`;

interface Props extends SlideElementProps {
  zIndex: number;
}
const DropShadow = React.forwardRef(
  ({zIndex}: Props, rootElRef: RefObject<HTMLDivElement>) =>
    (<Container ref={rootElRef} style={{zIndex}}/>),
);

export default DropShadow;
